import React, { Component } from "react";
import styled from "react-emotion";
import { Upload, Icon } from "antd";
import { connect } from "react-redux";
import * as actions from "../../../actions";
import { getBase64 } from ".././../../utils/helpers";

const UploadButton = styled("div")({
  width: "130px",
  marginRight: "10px",
  marginTop: "20px",
  ".upload": {
    div: {
      width: "100%"
    }
  }
});
class UploadImages extends Component {
  handleChange = async ({ file }) => {
    const { uid } = file;
    if (file && file.originFileObj) {
      const url = await getBase64(file.originFileObj);
      this.props.onAddingImage(url, uid, "upload");
    }
  };

  render() {
    return (
      <UploadButton>
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          listType="picture-card"
          fileList={[]}
          onChange={this.handleChange}
          showUploadList={false}
          className="upload"
        >
          <Icon type="plus" />
          <div className="ant-upload-text">Upload</div>
        </Upload>
      </UploadButton>
    );
  }
}

export default connect(
  null,
  actions
)(UploadImages);
